<template>
  <div>
    <container>
      <div slot="left_box_content">
        <component :is="curLeftComponent" ></component>
      </div>
      <div slot="right_box_content">
        <component :is="curRightComponent" ></component>
      </div>
      <div
        slot="bottom_box_content"
        style="padding:10px 10px;"
      >
        <component
          :is="curBottomComponent"
        ></component>
      </div>
      <div slot="bg_map"></div>
    </container>
  </div>
</template>

<script>
import Container from '@/components/common/Container'
import { sysMixins } from '@/assets/mixins/sys'
import settingStoreModule from '@/store/modules/setting'
export default {
  mixins: [sysMixins],
  components: {
    Container,
    WorkFlowComponent: () => import('@/components/setting/workflow/IndexTable'),
    Right: () => import('@/components/setting/workflow/Detail'),
    Left: () => import('./components/Left'),
    MessageComponent: () => import('@/components/setting/message/IndexTable')
  },
  data () {
    return {
    }
  },
  created () {
    if (!this.$store.hasModule('setting')) {
      this.$store.registerModule('setting', settingStoreModule)
      this.$store.commit('set_setting_companyId', this.$store.getters.token.userInfo.companyId)
      this.$store.commit('set_setting_publisherId', this.$store.getters.token.userInfo.publisherId)
    }
    this.initTagEvent()
  },
  methods: {
    initTagEvent () {
    // 注册头部事件
      this.setLinkRouterMaps(['workflow', () => {
        // this.$store.commit('set_setting_pageType', 'workflow')
      }])
    },

    initComponents () {
      // 清空便签项
      switch (this.settingType) {
        case 'workflow':
          this.setLeftComponent('Left')
          this.setRightComponent('Right')
          this.setShowLeftBlock(true)
          this.setShowMap(false)

          this.setBottomHeight('90%')
          this.setBottomComponent('WorkFlowComponent')
          if (this.pageType === 'default') {
            this.setShowRightBlock(false)
          } else if (this.pageType === 'setting') {
            this.setShowRightBlock(true)
          }

          break
        default:
          break
      }
    }
  },
  watch: {
    settingType (val) {
      this.initComponents()
    },
    pageType () {
      this.initComponents()
    }
  },
  computed: {
    settingType () {
      return this.$store.state.setting ? this.$store.state.setting.settingType : ''
    },
    pageType () {
      return this.$store.state.setting ? this.$store.state.setting.pageType : ''
    }
  },
  destroyed () {
    // 卸载reconciliation动态store模块
    this.$store.unregisterModule('setting')
    this.setShowLeftBlock(false)
    this.setShowMap(false)
    this.setShowRightBlock(false)
    this.setBottomHeight('90%')
    this.setLinkTagArray()
    this.setLinkRouterMaps()
    this.setActivedTagName('')
  }
}
</script>
